// Support QR component for the support page.

import ApiUtils from '@shared/utils/api';
import Container from '@components/atoms/container/supportQRContainer';
import QRGenerator from '@components/elements/qr/qrGenerator';
import { useMemo } from 'react';

/**
 * Support QR component for the support page.
 * Displays the QR code that links to the help page.
 *
 * @returns {JSX.Element} Support QR component
 */
export default function SupportQR() {
  const url = useMemo(() => ApiUtils.getUrl('help_link'), []);

  return (
    <Container>
      <QRGenerator scale={1.5} url={url} />
    </Container>
  );
}
